import { render, staticRenderFns } from "./ChangeDelivery.vue?vue&type=template&id=845ab706"
import script from "./ChangeDelivery.vue?vue&type=script&lang=js"
export * from "./ChangeDelivery.vue?vue&type=script&lang=js"
import style0 from "./ChangeDelivery.vue?vue&type=style&index=0&id=845ab706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports